import NotAvailable from './NotAvailable'

export default NotAvailable
// eslint-disable-next-line import/export
export * from './NotAvailable'
